export const DIRECTED = 'DIRECTED'
export const UNDIRECTED = 'UNDIRECTED'
export const BIDIRECTIONAL = 'BIDIRECTIONAL'
export const REVERSE = 'REVERSE'

export default {
  DIRECTED,
  UNDIRECTED,
  BIDIRECTIONAL,
  REVERSE
}
